import $ from 'jquery';

/**
 * Show/Hide extra Student fields if a user selects one of the student radio-tables
 */
class StudentFields {
    constructor () {
        // Student Membership Message show / hide
        this.$membershipRadios = $('.js-membership-containers input');
        this.$studentFields = $('.js-student-membership-message, .js-student-graduation-date');

        if (this.$membershipRadios.length) {
            const $selectedMemberRadio = this.$membershipRadios.filter(':checked');

            if ($selectedMemberRadio.length) {
                const membershipText = $selectedMemberRadio.parents('tr').children('td:first').text();

                this.toggleFields(membershipText);
            }

            this.$membershipRadios.on('change', (e) => {
                const $elem = $(e.currentTarget);
                const membershipText = $elem.parents('tr').children('td:first').text();

                this.toggleFields(membershipText);
            });
        }
    }

    toggleFields (selectionText) {
        if (selectionText.toLowerCase().indexOf('student') > -1) {
            this.$studentFields.slideDown(200);
        } else {
            this.$studentFields.slideUp(200);
        }
    }
}

export default StudentFields;
